import './ParamTree.less'

import { Button } from 'antd'
import api, { AppConfigParam, AppConfigParamGroup, AppParam, AppParamGroup, AppParamOutput } from 'api'
import { AppEvent } from 'components/AppEvent'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

import { ParamGroupEdit } from './ParamGroupEdit'
import ParamGroupItem from './ParamGroupItem'

interface Props {
	currSystemCode: string
	scope: number
	getConfigData?: (data: ParamGroup[]) => void
	data: AppParamOutput
	afterSave: () => void
}
export interface ParamGroup {
	paramGroup: any
	paramList: any[]
	type: number // 参数类型 0：配置类参数，1：选项类参数
}
export let ParamTree = (props: Props) => {
	// const[showData,setshowData] = useState([] as ParamGroup[])
	const [paramList, setParamList] = useState([] as ParamGroup[])
	useEffect(() => {
		getData()
	}, [props.data, props.scope])

	// 获取参数列表
	const getData = async () => {
		let res = props.data
		if (JSON.stringify(res) === '{}') {
			return
		}
		// 配置类参数组
		let appConfigParamGroupList = res.appConfigParamGroupList
		// 配置类参数
		let appConfigParamList = res.appConfigParamList
		let configDataList = [] as ParamGroup[]
		appConfigParamGroupList.forEach((appConfigParamGroup: AppConfigParamGroup) => {
			let list = appConfigParamList.filter((appConfigParam: AppConfigParam) => {
				return appConfigParam.groupId === appConfigParamGroup.id
			})
			let paramGroup = {
				paramGroup: appConfigParamGroup,
				paramList: list,
				type: 0,
			}
			configDataList.push(paramGroup)
		})
		props.getConfigData && props.getConfigData(configDataList)
		// 选项类参数组
		let appParamGroupList = res.appParamGroupList
		// 选项类参数
		let appParamList = res.appParamList
		let paramMidList = [] as ParamGroup[]
		appParamGroupList.forEach((appParamGroup: AppParamGroup) => {
			let list = appParamList.filter((appParam: AppParam) => {
				return appParam.groupId === appParamGroup.id && appParam.scope === props.scope
			})
			let paramGroup = {
				paramGroup: appParamGroup,
				paramList: list,
				type: 1,
			}
			paramMidList.push(paramGroup)
		})
		setParamList(paramMidList)
	}
	// 新增配置分组
	const saveConfigParamGroup = async () => {
		let testConfigParamGroup = {
			application: props.currSystemCode,
			showName: '测试用参数2',
			sort: '2',
		} as AppConfigParamGroup
		let res = await api.modeling.param.saveConfigParamGroup(testConfigParamGroup)
	}

	// 新增分组下的参数明细
	const saveConfigParam = async () => {
		let testConfigParam = {
			application: props.currSystemCode,
			groupId: 662340542368,
			showName: '电话',
			keyName: 'tel',
			scope: 1,
			type: 0,
			sort: '1',
			describe: '公司级电话参数',
		} as AppConfigParam
		let res = await api.modeling.param.saveConfigParam(testConfigParam)
	}

	// 新增选项类参数分组
	const saveParamGroup = async () => {
		let testParamGroup = {
			application: props.currSystemCode,
			showName: '选择类参数3',
			sort: '0',
		} as AppParamGroup
		let res = await api.modeling.param.saveParamGroup(testParamGroup)
	}

	// 新增选项类参数明细
	const saveParam = async () => {
		let testParam = {
			application: props.currSystemCode,
			groupId: 662372689248,
			showName: '性别列表',
			keyName: 'sexList',
			scope: 1,
			paramType: 0,
			pageUrl: '/testPath',
			sort: '1',
			describe: '公司级选项类参数(分组2)',
		} as AppParam
		let res = await api.modeling.param.saveParam(testParam)
	}

	const addParamGroup = () => {
		AppEvent.openDialog(
			<ParamGroupEdit mode={1} application={props.currSystemCode} scope={props.scope} afterSave={afterSave} />,
			{
				title: '新增分组',
				size: 'small',
			}
		)
	}

	const afterSave = () => {
		props.afterSave && props.afterSave()
	}

	return (
		<div style={{ width: 290, border: '1px solid rgb(232, 232, 232)' }}>
			<div
				style={{
					height: 40,
					borderBottom: '1px solid rgb(232, 232, 232)',
					backgroundColor: 'rgb(244, 245, 249)',
					paddingTop: 8,
					paddingLeft: 20,
				}}
			>
				<span>业务参数</span>
				<span style={{ marginLeft: 160 }}>
					<Button
						type="primary"
						shape="circle"
						icon="plus"
						style={{ fontSize: '12px' }}
						size="small"
						title="新增分组"
						onClick={addParamGroup}
					/>
				</span>
			</div>
			<div />
			<div className="navMenu">
				<div className="result">
					<div>配置参数类</div>
					{paramList.map((v, k) => {
						return (
							<ParamGroupItem
								key={k}
								menu={v.paramGroup}
								item={v.paramList}
								afterSave={afterSave}
								scope={props.scope}
								application={props.currSystemCode}
							></ParamGroupItem>
						)
					})}
				</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/param/components/ParamTree.tsx